export default "__VITE_ASSET__D6Qd1Ddw__"